/* eslint-disable react/react-in-jsx-scope */
import {
  createContext, useEffect, useRef, useMemo, ReactNode
} from 'react';
import { useLocation } from 'react-router-dom';

interface NavigationContextType {
  previousPath: string | null;
}

export const NavigationContext = createContext<NavigationContextType>({
  previousPath: null,
});

export function NavigationProvider({ children }: { children: ReactNode }) {
  const location = useLocation();
  const previousPathRef = useRef<string | null>(null);

  useEffect(() => {
    previousPathRef.current = location.pathname + location.search;
  }, [location]);

  const contextValue = useMemo(() => ({
    previousPath: previousPathRef.current,
  }), [previousPathRef.current]);

  return (
    <NavigationContext.Provider value={contextValue}>
      {children}
    </NavigationContext.Provider>
  );
}
